export default "__VITE_ASSET__CJhiYk_H__"